import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {setStep} from "../../../redux/actions/stepActions";
import GuestBar from "../../../components/GuestInfo/GuestBar";
import {Breadcrumbs, Container, Grid, Link, Typography} from "@mui/material";
import GuestInfoStepper from "../../../components/GuestInfo/GuestInfoStepper";
import {Formik} from "formik";
import DivingForm from "../../../components/GuestInfo/GuestForm/DivingForm";
import {Link as RouterLink, useHistory, useParams} from "react-router-dom";
import {getBookingFormData, updateBookingFormData} from "../../../redux/actions/bookingFormActions";
import {useIsAuthenticated} from "react-auth-kit";
import ValidateAccess from "../../../components/ValidateAccess/ValidateAccess";
import {requestApi, showAlertAutoDis} from "../../../utils/utils";
import {format, parse} from "date-fns";
import PreTripCard from "../../../components/GuestInfo/MyBooking/PreTripCard";

const heightOptions = ['feet', 'inch', 'cm'];
const weightOptions = ['lb', 'kg'];
const shoeSizeOptions = ['us', 'cm', 'eu', 'uk'];

const getNumericAndUnitValue = (stringValue = '', acceptableUnits = []) => {
    let number = '';
    let unit = '';
    if (!stringValue) return {number, unit};
    const digits = stringValue.match(/[\d.]+/);
    if (!digits) return {number, unit};
    number = digits[0];
    unit = getUnit(stringValue, acceptableUnits);
    return {number, unit};
};

const getUnit = (value, units) => {
    if (units.includes('feet') && (value.toLowerCase().includes("ft") || value.includes("'")))
        return 'feet';
    if (units.includes('inch') && (value.includes('"') || value.toLowerCase().includes('in.')))
        return 'inch';

    for (let unit of units) {
        if (value.toLowerCase().includes(unit))
            return unit;
    }
    return '';
};

const DivingPage = () => {
    ValidateAccess();
    const dispatch = useDispatch();
    const {id} = useParams();
    const {booking, form} = useSelector(state => state.bookingForm);
    const isAuth = useIsAuthenticated();
    const history = useHistory();


    const initialValues = {
        diveCertAgency: form?.diveCertAgency || '',
        diveCertNumber: form?.diveCertNumber || '',
        nitroxCertAgency: form?.nitroxCertAgency || '',
        nitroxCertNum: form?.nitroxCertNum || '',
        injuryYesNo: !!(form?.injuryYesNo),
        injury: form?.injury || '',
        height: getNumericAndUnitValue(form?.height, heightOptions).number || '',
        heightUnit: getNumericAndUnitValue(form?.height, heightOptions).unit || 'feet',
        weight: getNumericAndUnitValue(form?.weight, weightOptions).number || '',
        weightUnit: getNumericAndUnitValue(form?.weight, weightOptions).unit || 'lb',
        shoesize: getNumericAndUnitValue(form?.shoesize, shoeSizeOptions).number || '',
        shoeSizeUnit: getNumericAndUnitValue(form?.shoesize, shoeSizeOptions).unit || 'us',
        diverType: form?.diverType || '',
        diverDives: form?.diverDives || '',
        diverYears: form?.diverYears || '',
        diverFitness: form?.diverFitness || '',
    };

    useEffect(() => {
        dispatch(setStep(3));
    }, []);

    useEffect(() => {
        if (!booking || form.guestFk !== parseInt(id))
            getGuestAndTrip().catch();
        if (booking && booking?.trip?.location?.tripTypeFk === 2)
            return history.push(`/booking/guest/${id}/medical-insurance`);
    }, [booking?.id]);

    const getGuestAndTrip = async () => {
        const accessToken = sessionStorage.getItem('accessToken');
        dispatch(getBookingFormData(id, accessToken));
    };

    const handleSubmitDivingForm = async (values) => {
        const guestId = form.guestFk;

        const params = {
            ...values,
            height: `${values.height} ${values.heightUnit}`,
            weight: `${values.weight} ${values.weightUnit}`,
            shoesize: `${values.shoesize} ${values.shoeSizeUnit}`,
        };

        const access = sessionStorage.getItem('accessToken');
        if (access) params['guestCode'] = access;

        dispatch(updateBookingFormData(params, id));
        const guestCode = access ? `?guestCode=${access}` : '';

        const {data} = await requestApi(`/guest/save-rentals/${guestId}${guestCode}`, 'POST', {rentals: values.rentals});

        if (data.status === 'success') {
            // return history.push(`/booking/guest/${id}/park-fees`);

			let url = `/booking/guest/${id}/park-fees`;
            if (booking.trip.location.tripTypeFk === 2)
                url = `/booking/guest/${id}/extra-activities`;
            return history.push(url);
        } else {
            return showAlertAutoDis({title: 'Error', text: 'Unable to save rental information'});
        }
    };


    return (
        <>
            {isAuth() && booking && <GuestBar>
                <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                    <Link component={RouterLink} underline="hover" color="inherit" to="/booking/my-bookings">
                        Bookings
                    </Link>
                    <Link component={RouterLink} underline="hover" color="inherit" to={`/booking/my-bookings/${booking.id}`}>
                        {format(parse(booking.tripDate, 'yyyy-MM-dd', new Date()), 'LLLL d, yyyy')}
                    </Link>
                    <Typography color="text.primary">{form?.guestInfo?.firstName ? `${form.guestInfo.firstName} ${form.guestInfo.lastName}` : 'Guest Form'}</Typography>
                </Breadcrumbs>
            </GuestBar>}
            {booking && <Container>
                <GuestInfoStepper/>
                <div style={{marginTop: 50}}>
                    <Grid container spacing={3} sx={{px: {xs: '1.6rem', lg: '0'}}}>
                        <Grid item xs={12} sm={12}>
                            {booking.trip && <PreTripCard booking={booking}/>}
                        </Grid>
                        <Grid item xs={12} style={{marginTop: 50}}>
                            <Formik initialValues={initialValues} onSubmit={(values) => handleSubmitDivingForm(values)}>
                                {(props) => <DivingForm {...props} />}
                            </Formik>
                        </Grid>
                    </Grid>
                </div>
            </Container>}
        </>
    );
};

export default DivingPage;